/**
 *
 * @module paymentCardType
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef PaymentCardType
 * @type {Object}
 * @desc An enumeration of recognized payment methods.
 * @note These values are returned from the service in UPPERCASE.
 *
 * @property {String} DEBIT
 * @property {String} CREDIT
 *
 */

/**
*
* @enum
* @type {PaymentCardType}
*
*/
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    DEBIT: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    CREDIT: null
});



// WEBPACK FOOTER //
// ./src/services/commerce/paymentCardType.js